import clsx from "clsx";

interface SourceProgressProps {
  current: number;
  total: number;
  isDisconnected?: boolean;
}

export default function SourceProgress({
  current,
  total,
  isDisconnected = false,
}: SourceProgressProps) {
  const percentage = total > 0 ? Math.min((current / total) * 100, 100) : 0;

  return (
    <div className="flex flex-row items-center gap-2 justify-between">
      <div className="w-full flex-start flex overflow-hidden rounded-full border border-black-200 bg-transparent p-0.75">
        <div className="flex-start flex h-1.5 w-full overflow-hidden rounded-full bg-black-200">
          <div
            className={clsx(
              "flex items-center justify-center h-full overflow-hidden rounded-full",
              isDisconnected
                ? "bg-[linear-gradient(90deg,#E2E2E2_0%,#C3C3C3_100%)]"
                : "bg-gradient-to-r from-green-200 to-green-300",
            )}
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
      </div>

      <span
        className={clsx("text-xs-bold", isDisconnected && "text-black-400")}
      >
        {current}
        <span className="text-black-400">/{total}</span>
      </span>
    </div>
  );
}
